import React from "react";
import { ReactSVG } from "react-svg";

import arrow from "../../assets/svg/arrow-s.svg";

export default function StudentWeekToolbar({ label, onToday, onPrev, onNext }) {
   return (
      <div className="sWeekCal__toolbar">
         <div className="sWeekCal__toolbarLeft">
            <button type="button" onClick={onToday}>
               Astăzi
            </button>
         </div>

         <div className="sWeekCal__toolbarCenter">
            <span className="sWeekCal__toolbarLabel">{label}</span>
         </div>

         <div className="sWeekCal__toolbarRight">
            <button type="button" onClick={onPrev} aria-label="Ziua anterioară">
               <ReactSVG className="sWeekCal__btnIcon" src={arrow} />
            </button>
            <button type="button" onClick={onNext} aria-label="Ziua următoare">
               <ReactSVG className="sWeekCal__btnIcon sWeekCal__btnIcon--flip" src={arrow} />
            </button>
         </div>
      </div>
   );
}
